import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

// Grab the root DOM element
const container = document.getElementById('root');
const root = createRoot(container);

// Render the main App component
root.render(<App />);
